import React, { useState } from 'react';
import { Modal } from '../../../../Common/fModal/Modal';
import { SearchableSelect } from '../../../../Common/Class/Select/SearchableSelec';
import { get } from '../../../../../Model/Network/Config/Axios';
import { showToast } from '../../../../Common/fToast/ToastCallback';

export const GinLink = ({ onClose, onLink }) => {
    const [selected, setSelected] = useState(undefined)
    const [items, setItems] = useState([])

    const onChange = q => {
        if (q.length > 0) {
            get(`/vendor/procurement/gin/search`, (e, r) => {
                if (r) {
                    setItems(r.asnList.map(item => ({
                        label: item.ginId,
                        value: item.id,
                    })))
                }
            }, {
                q
            })
        } else {
            setItems([])
        }
    }


    return (
        <Modal style={{
            save: {
                background: "var(--primary-color)",
                width: "100%",
                border: "2px solid var(--primary-color)",
                padding: '12px 15px',
                textAlign: 'center'
            }
        }}
            title={"Link GIN"}
            des="Please select gin to add."
            onSave={() => {
                if (!selected) {
                    showToast({
                        type: 'error',
                        message: 'Please select a gin'
                    })
                    return
                }
                onLink(selected.value)
            }}
            buttonName={'Link GIN'}
            show={true}
            close={onClose}
        >
            <div className="light-group" style={{ marginBottom: 20 }}>
                <SearchableSelect
                    items={items}
                    onChange={onChange}
                    label={"Search GIN"}
                    placeholder={"Search GIN"}
                    select={setSelected}
                    value={selected}
                />
            </div>
        </Modal>
    )
}